import React, { useEffect, useState } from 'react';
import styles from './payment.module.css'
import TableCompo from '../../components/table/TableCompo';
import axios from 'axios';

const Payment = () => {
    const [uptodate, setUptodate] = useState([]);
    const [data, setData] = useState({});
    const [prevData, setPrevData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState(null);

    const [page, setPage] = useState(() => {
        const saved = localStorage.getItem('pageno-payment');
        return {
            pageno: saved ? Number(saved) : 1,
            totalPage: 0,
            totalData: 0
        };
    });

    const fetchData = async (pageno) => {
        const cached = data[pageno];
        if (cached) {
            setPrevData(cached);
            return;
        }

        setIsLoading(true);
        try {
            const url = `${process.env.REACT_APP_URL}/api/payments/fetch?page=${pageno}&limit=20`;
            const res = await axios.get(url, { withCredentials: true });

            if (res.status === 200) {
                console.log(res.data)
                const list = res.data?.dataList || [];
                setData(prev => ({ ...prev, [pageno]: list }));
                setPrevData(list);
                setMessage(res.data.message);
                setUptodate(res.data.isLastSunday ? 1 : 0);

                setPage(prev => ({
                    ...prev,
                    totalPage: Math.ceil(res.data.total / 20),
                    totalData: res.data.total,
                }));

            }
        } catch (err) {
            console.error("Error fetching data:", err);
            setMessage(err.response?.data?.message || 'An error occurred while fetching data.');
            setUptodate(null)
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        localStorage.setItem('pageno-payment', page.pageno);
        fetchData(page.pageno);
    }, [page.pageno]);


    const handleGenerate = async () => {
        try {
            const result = await axios.get(`${process.env.REACT_APP_URL}/api/payments/generate`,
                { withCredentials: true }
            );
            if (result.status === 200) {

                // setMessage(null)

                // setData({});
                setData(prev => {
                    const newData = { ...prev };

                    newData[1] = [
                        ...result.data.insertedData,
                        ...(newData[1] || [])
                    ];
                    return newData;
                });
                setUptodate(1);
                setMessage(null);

            }
        } catch (error) {
            console.error(error);
        }
    };


    return (
        <div className={styles.container}>
            <TableCompo
                title={"Payment"}
                url={"api/payments/fetch"}
                search={false}
                view={false}
                generate={true}
                data={data}
                prevData={prevData}
                page={page}
                setPage={setPage}
                isLoading={isLoading}
                message={message}
                uptodate={uptodate !== null ? uptodate : null}
                handleGenerate={handleGenerate}

            />
        </div >
    );
};

export default Payment;
